<template>
  <v-layout row wrap>
    <v-flex xs6>
      <div>
        <div class="caption">{{ $t('Group') }}</div>
        <p class="primary-color">
          {{
            intentgroup.assigngroupid && agentGroup.find((el) => el.id == intentgroup.assigngroupid)
              ? agentGroup.find((el) => el.id == intentgroup.assigngroupid).groupname
              : '-'
          }}
        </p>
      </div>
    </v-flex>
    <v-flex xs6>
      <div>
        <div class="caption">{{ $t('Sub Group') }}</div>
        <p class="primary-color">
          {{
            intentgroup.assignsubgroupid &&
            agentSubGroup.find((el) => el.id == intentgroup.assignsubgroupid)
              ? agentSubGroup.find((el) => el.id == intentgroup.assignsubgroupid).subgroupname
              : '-'
          }}
        </p>
      </div>
    </v-flex>
    <v-flex xs6>
      <div>
        <div class="caption">{{ $t('Priority') }}</div>
        <p class="primary-color">
          {{ intentgroup.priority ? intentgroup.priority : '-' }}
        </p>
      </div>
    </v-flex>
    <v-flex xs6>
      <div>
        <div class="caption">{{ $t('Due Date') }}</div>
        <p class="primary-color">
          {{ intentgroup.duedate ? intentgroup.duedate : '-' }}
        </p>
      </div>
    </v-flex>
    <v-flex xs6>
      <div>
        <div class="caption">{{ $t('Tags') }}</div>
        <p class="primary-color">
          {{ intentgroup.tags ? intentgroup.tags : '-' }}
        </p>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['intentgroup'],
  computed: {
    ...mapGetters({
      agentGroup: 'getAgentGroup',
      agentSubGroup: 'getAgentSubgroup'
    })
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/Ticket/IntentTicketGroup.vue